import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { CarouselSlideCardBlockConfig } from '@front-platform/content-builder';
import { carouselSlideCardBlockResolveConfig } from '@front-platform/content-builder';
import { Component, input } from '@angular/core';
import {
  IContentBuilderFieldColor,
  IContentBuilderFieldImage,
} from '@core/models/content-builder-fields.model';
import { carouselSlideCardMediaStyles } from './carousel-slide-card-media';
export interface CarouselSlideCardBlockRuntimeConfig {
  'slides'?: any[] | undefined;
  '"aspect-ratio"'?: number;
}

export type CarouselSlideCardBlockConfigInput = Partial<
  Omit<CarouselSlideCardBlockConfig, keyof CarouselSlideCardBlockRuntimeConfig> &
    CarouselSlideCardBlockRuntimeConfig
>;
export type CarouselSlideCardBlockResolvedConfig = Omit<
  CarouselSlideCardBlockConfig,
  keyof CarouselSlideCardBlockRuntimeConfig
> &
  Partial<CarouselSlideCardBlockRuntimeConfig>;
export interface CarouselSlideCardBlockContract extends ConfigComponentContract<
  CarouselSlideCardBlockConfigInput,
  CarouselSlideCardBlockResolvedConfig
> {}

@Component({
  selector: 'app-carousel-slide-card-block',
  templateUrl: './carousel-slide-card-block.component.html',
  styleUrls: ['./carousel-slide-card-block.component.scss'],
  standalone: false,
})
export class CarouselSlideCardBlockComponent implements CarouselSlideCardBlockContract {
  readonly config = input<CarouselSlideCardBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    CarouselSlideCardBlockConfig,
    CarouselSlideCardBlockRuntimeConfig
  >(carouselSlideCardBlockResolveConfig, () => ({ config: this.config() }));
  get slides(): any[] | undefined {
    return this.resolvedConfig()['slides'] as unknown as any[] | undefined;
  }
  get width(): string {
    return this.resolvedConfig()['width'] as unknown as string;
  }
  get height(): string | undefined {
    return this.resolvedConfig()['height'] as unknown as string | undefined;
  }
  get aspectRatio(): string | number | undefined {
    const resolved = this.resolvedConfig();
    return (resolved['"aspect-ratio"'] ?? resolved['aspect-ratio']) as unknown as
      string | number | undefined;
  }
  get linkUrl(): string | undefined {
    return this.resolvedConfig()['link_url'] as unknown as string | undefined;
  }
  get tag(): string | undefined {
    return this.resolvedConfig()['tag'] as unknown as string | undefined;
  }
  get backgroundImage(): IContentBuilderFieldImage | undefined {
    return this.resolvedConfig()['background_image'] as unknown as
      IContentBuilderFieldImage | undefined;
  }
  get backgroundColor(): IContentBuilderFieldColor {
    return this.resolvedConfig()['background_color'] as unknown as IContentBuilderFieldColor;
  }
  get mediaStyles(): { aspectRatio: string | null; height: string | null } {
    return carouselSlideCardMediaStyles(this.height, this.aspectRatio);
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(CarouselSlideCardBlockComponent, {
  'keyAliases': { 'aspect_ratio': '"aspect-ratio"' },
});
